import React, { useState, useEffect, useCallback } from 'react';
import { InputText } from 'components/common/input';
import BaseModalForm from 'components/common/modal/BaseModalForm';
import { useFormHandlers } from 'core/hooks/form/formHandlers';
import { Alert } from 'react-bootstrap';
import { MODAL_FORM_ERRORS } from 'core/constant/MODAL_FORM_ERRORS';

const EditFaqModal = ({ show, faq, handleClose, handleSave, updating, errors, requestError }) => {
  const [formValues, setFormValues] = useState(faq);
  const { handleChange } = useFormHandlers(setFormValues);

  useEffect(() => {
    setFormValues(faq);
  }, [faq]);

  const handleSaveClick = useCallback(() => {
    handleSave({ ...formValues, id: faq?.id });
  }, [formValues, faq?.id, handleSave]);

  return (
    <BaseModalForm show={show} title={faq?.id ? "Editar FAQ" : "Crear FAQ"} handleClose={handleClose} handleSave={handleSaveClick} updating={updating}>
      <div className="row">
        <div className="col-md-6 form-group">
          <InputText
            label="Pregunta"
            name="question"
            value={formValues?.question}
            onChange={(e) => handleChange('question', e.target.value)}
            placeholder="Ingrese la pregunta"
            error={errors.question}
          />
        </div>
        <div className="col-md-6 form-group">
          <InputText
            label="Respuesta"
            name="answer"
            value={formValues?.answer}
            onChange={(e) => handleChange('answer', e.target.value)}
            placeholder="Ingrese la respuesta"
            error={errors.answer}
          />
        </div>
        <div className="col-12 form-group mt-3">
          {requestError &&
            <Alert variant="danger">
              {requestError?.response?.data?.message ||
               MODAL_FORM_ERRORS.FAQ}
            </Alert>
          }
        </div>
      </div>
    </BaseModalForm>
  );
};

export default React.memo(EditFaqModal);